import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';

import { getInlineCommentExperienceContext } from '@confluence/experience-tracker/entry-points/getInlineCommentExperienceContext.ts';

export function handleAnalyticsEvents(objectId: string) {
	return (event: UIAnalyticsEvent): void => {
		event.update((payload) => ({
			...payload,
			attributes: {
				...payload.attributes,
				...(payload.action === 'viewed' &&
				payload.actionSubject === 'annotation' &&
				payload.actionSubjectId === 'inlineComment'
					? getInlineCommentExperienceContext(payload.attributes?.annotationId, 'view')
					: {}),
				objectId,
			},
		}));
	};
}
